export const PALETTE = {
  background: 0xdcebf0,
  ground: 0xd8daca,
  grid: 0x16233a,
  black: 0x090b10,
  structure: 0xe5d8bd,
  structureLight: 0xb8d6df,
  blue: 0x328bc4,
  yellow: 0xf1bd42,
  red: 0xc85562,
  teal: 0x329a88,
  client: 0x168bff,
  parse: 0xffd21c,
  execute: 0x168bff,
  buffer: 0x168bff,
  undo: 0xff2638,
  redo: 0xffd21c,
  commit: 0xff2638,
  storage: 0x329a88,
  inactive: 0x252a33,
  white: 0xf7fbff,
} as const;
